module.exports = __webpack_public_path__ + "static/7-cd172bf04a74c3c93c55e3564fe1e7b1.jpg";